export default function isHttpError(res: any) {
  // ネットワークエラー時はステータスコードがundefinedのため、!res.statusで対応
  return !res.status || (res.response && res.response.status !== 200)
}
